import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScanPageComponent } from './scan/scan-page.component';
import { SearchPageComponent } from './search/search-page.component';
import { SharedModule } from '../shared/shared.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { SearchComponent } from './search/search/search.component';
import { MatListModule } from '@angular/material/list';

import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';

import { RoesbergModule } from '@ldw/roesberg';
import { ScanModule } from '../scan/scan.module';
import { DocumentsModule } from '../documents/documents.module';

@NgModule({
  declarations: [ScanPageComponent, SearchPageComponent, SearchComponent],
  exports: [SearchPageComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatToolbarModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatIconModule,
    MatCardModule,
    TranslateModule,
    MatListModule,
    RoesbergModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatTooltipModule,
    ScanModule,
    DocumentsModule
  ]
})
export class SearchModule {}
